<template lang="pug">
  #app.top-area.w-full.flex.flex-col.bg-gray-900(:class='mainClass')
    //video(src='http://playboxcade-next-pbccontentnext6373d11d-1jk30yops1pkh.s3-website-eu-west-1.amazonaws.com/videos/52347bc8-d72b-43b4-b116-6c041ff7f262.mp4?pixi=1',muted,controls,width="200",height="200",playsinline,autoplay)
    router-view(:class='routerClasses')

    pbc-message(ref='message')
    .fixed.top-0.bottom-0.left-0.right-0.pbc-z-level-4(v-if='loadingChunkedPage || isLoadingStash')
      loading.pbc-z-level-4

    change-username-dialog(v-if='forceUsernameChange',@close='changedUsername')
    auth-dialog(v-if='showLoginDialog',:enable-guest='false',@close='onCloseAuthDialog')

    prompt-install-app-dialog(v-if='showAppInstallPrompt',@add='doInstallAppFlow',@close='onApAddedCancelled')
    prompt-install-notifications-dialog(v-if='showNotificationsInstallPrompt',@add='onNotificationsInstallConfirmed',@close='onNotificationsInstallCancelled')

    portal-target(name="main-modal")

    nav-bar#nav-bar.flex-none(v-if='showNavbar',:user='user')

    pbc-confirmation(v-if='showConfirmNavigateAwayFromEditor',
                     @ok='doNavigateAwayFromEditor',
                     @cancel='navigateAwayFromEditor(false); navigateAwayFromEditor = null')
      h3.text-gray-700 Are you sure? You may lose unsaved work.

    client-only
      ana
    svg-icon-sprite-sheet.hidden

    .fixed.top-0.left-0.text-white#hax

    portal-target(name="last-modal")

</template>

<script>


import AuthDialog from '@ui/organisms/AuthDialog.vue';
import ClientOnly from 'vue-client-only'
import { mapState } from 'vuex';
import { VuePwaInstallMixin } from "vue-pwa-install";
import Auth from '@aws-amplify/auth'
import Loading from '@ui/atoms/Loading.vue';
import { whoamiQuery, savePostDraftQuery, getPostDraftsQuery } from '@/gql/Queries.js';
import gql from 'graphql-tag';
import SvgIconSpriteSheet from '@ui/atoms/SvgIconSpriteSheet.vue';
import { debounce } from 'lodash';
import vhCheck from '@/vendor/vh-check.js';

import topProgress from 'vue-top-progress'
import NavBar from '@ui/molecules/NavBar.vue';
import PbcMessage from '@ui/molecules/PbcMessage.vue';

import getProviders from '@ui/apiprovider.js';

import ChangeUsernameDialog from '@ui/molecules/ChangeUsernameDialog.vue';
import PromptInstallAppDialog from '@ui/molecules/PromptInstallAppDialog.vue';
import PromptInstallNotificationsDialog from '@ui/molecules/PromptInstallNotificationsDialog.vue';

const Ana = () => import(/* webpackChunkName: ana */ '@ui/atoms/Ana.vue');


export default {
  mixins: [VuePwaInstallMixin],
  name: 'App',
  provide: getProviders,
  metaInfo() {
    const url = `https://${process.env.VUE_APP_DOMAIN_NAME}`;
    return {
      title:'animated interactive memes and animations',
      titleTemplate:'Playboxcade - %s',
      meta:[
        { vmid:'n_des',name:'description',content:'Create animated, interactive memes and animations.'},
        { vmid:'des', property:'description',content:'Create animated, interactive memes and animations.'},
        { vmid:'og_des', property:'og:description',content:'Create animated, interactive memes and animations.'},
        { vmid:'og_title', property:'og:title',content:'Playboxcade'},
        { vmid:'og_image', property:'og:image',content:url + '/img/icons/android-chrome-512x512.png'},
        { vmid:'og_image_w', property:'og:image:width',content:'512'},
        { vmid:'og_image_h', property:'og:image:height',content:'512'},
        { vmid:'og_image_alt', property:'og:image:alt',content:'Playboxcade'},
        { vmid:'og_url', property:'og:url',content:url},
        //{ property:'og:image:width',content:this.description},
        //{ property:'og:image:height',content:this.description},
        { vmid:'og_type', property:'og:type',content:'website'}
      ]

    }
  },
  components:{
    SvgIconSpriteSheet,
    topProgress,
    PbcMessage,
    NavBar,
    AuthDialog,
    Loading,
    ChangeUsernameDialog,
    PromptInstallAppDialog,
    PromptInstallNotificationsDialog,
    Ana,
    ClientOnly
  },
  data() {
    return {
      loadingChunkedPage: false,
      user: {
        id: 'anonymous',
        username: 'anonymous',
        anonymous: true
      },
      deferredInstallPrompt: undefined,
      showNotificationsInstallPrompt:false,
      hasPosted: false,
      navigateAwayFromEditor: null,
      redirectAfterLogin: '',
      isLoadingStash: false
    }
  },
  beforeDestroy() {
    window.removeEventListener('touchmove', this.updateVhCheck);
  },
  beforeCreate() {
    if (typeof(window) !== 'undefined') {
      window.__apolloLoaderCallback = (isLoading) => {
        if (isLoading) {
          this.startLoading("gql");
        } else {
          this.stopLoading("gql");
        }
      }
    }
  },
  created() {
    this.$on("canInstall", (event) => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt:
      event.preventDefault();

      // Stash the event so it can be triggered later:
      this.deferredInstallPrompt = event;
    });
  },
  mounted() {
    //setTimeout( () => {
      //this.handleStash("50a93dd0-de02-4c55-a53d-8889ead4592d");
    //}, 800);
    this.onVhCheckUpdate = debounce(this._onVhCheckUpdate, 200);
    this.updateVhCheck = debounce(this._updateVhCheck, 400);
    this.lastVhValue = -1;
    this.vhcheck = vhCheck({
      force: true,
      redefineVh: true,
      updateOnTouch: false,
      onUpdate: this.onVhCheckUpdate.bind(this)
    })
    window.addEventListener('touchmove', this.updateVhCheck);

    this.$vhcheck.on('recompute', () => {
      //const {isNeeded, value, vh, windowHeight, offset} = this.vhcheck.recompute();

      this.vhcheck.forceRecompute();
    });

    this.$eventbus.on('startLoadingPage', () => {
      this.loadingChunkedPage = true;
    });
    this.$eventbus.on('doneLoadingPage', () => {
      this.loadingChunkedPage = false;
    });

    this.$eventbus.on('posted', () => {
      this.hasPosted = true;
    });
    this.$eventbus.on('installApp', async () => {
      this.doInstallAppFlow();
    });


    this.$amplify.Hub.listen('auth', (data) => {
      console.log('Hub event', data);
      switch (data.payload.event) {
        case 'signIn':
          console.log('Hub: now the user is signed in');
          this.readUser();
          break;
        case 'signIn_failure':
          console.log('Hub: the user failed to sign in');
          console.log('the error is', data.payload.data);
          break;
        case 'signOut':
          console.log('Hub: the user signed out');
          break;
        default:
          console.log('Hub default');
          if (data.payload.event === "customOAuthState") {

            console.log('incoming shitty fucking data', data.payload.data);
            const stashId = decodeURIComponent(data.payload.data);

            console.log('recired stashID!!!!!!!', stashId);
            if (stashId.indexOf('redirect_') === 0) {
              if (stashId === 'redirect_localmemes') {
                console.log('move to user posts!!!', this.user);
                if (this.user.username !== 'anonymous') {
                  this.$router.push({
                    name:'userposts',
                    params:{
                      username:this.user.username
                    }
                  });
                } else {
                  this.__redirectToUser = 'userposts'
                }
              } else {
                console.error('nah', stashId);
              }
            } else {
              this.handleStash(stashId);
            }

/*
            const stateData = JSON.parse(decodeURIComponent(decodeURIComponent(data.payload.data)));
            console.log('stateData', stateData);
            if (stateData.redirect === 'draft') {
              this.$router.push({
                name:'create',
                params:{
                  parentId:stateData.parentId,
                  draftId:stateData.draftId,
                  stash:stateData.stash,
                  autoPost:true
                }
              });
            } else if (stateData.redirect === 'text') {
              this.$router.push({
                name:'createTextPost',
                params:{
                  id:stateData.parentId,
                  body:stateData.body,
                  autoPost:true
                }
              });
            } else if (stateData.redirect === 'image') {
              this.$router.push({
                name:'createImagePost',
                params:{
                  id:stateData.parentId,
                  title:stateData.title,
                  image:stateData.image,
                  autoPost:true
                }
              });
            } 
            */
 
          }
          break;
      }
    });

    if (this.$messaging) {
      this.$messaging.onTokenRefresh(() => {
        this.$messaging.getToken().then((refreshedToken) => {
          console.log('Token refreshed.');
          // Indicate that the new Instance ID token has not yet been sent to the
          // app server.
          setTokenSentToServer(false);
          // Send Instance ID token to app server.
          sendTokenToServer(refreshedToken);
          // ...
        }).catch((err) => {
          console.log('Unable to retrieve refreshed token ', err);
          showToken('Unable to retrieve refreshed token ', err);
        });
      });

      this.$messaging.onMessage((payload) => {
        console.log('Message received. ', payload);
        // ...
      });
    }

    this.$eventbus.on('serviceWorkerUpdated', (registration) => {
      alert("Update available!");
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
      //registration.skipWaiting();
    });

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        // We'll also need to add 'refreshing' to our data originally set to false.
        if (this.refreshing) return
          this.refreshing = true
        // Here the actual reload of the page occurs
        window.location.reload()
      })
    }

    this.$eventbus.on('navigateAwayFromEditor', ({next}) => {
      this.navigateAwayFromEditor = next;
    });

    this.readUser();

    if (!!this.$route.query.jid) {
      console.log('IS AYOBA!!!!!!!');
      this.$store.commit('setIsAyoba', true);
    }
  },

  methods:{
    onCloseAuthDialog() {
      this.$router.replace({
        query:{
          loginPrompt:undefined
        }
      });
    },
    doNavigateAwayFromEditor() {
      this.navigateAwayFromEditor();
      this.navigateAwayFromEditor = null;
    },
    _updateVhCheck() {
      const data = this.vhcheck.forceRecompute();
      //this.onVhCheckUpdate(data);
    },
    _onVhCheckUpdate({isNeeded, value, vh, windowHeight, offset}) {
    //_onVhCheckUpdate() {
      //const {isNeeded, value, vh, windowHeight, offset} = this.vhcheck.recompute();
      if (!isNeeded) {
        if (value !== this.lastVhValue) {
          /*
          this.$refs.message.show({
            title:`vh-check: isNeeded: ${isNeeded} value: ${value} vh: ${vh} windowHeight: ${windowHeight} offset: ${offset}`
          });
          */
          this.lastVhValue = value;
          this.$vhcheck.emit('update');
        }
        return;
      }
      /*
      let lol;
      if (window.visualViewport) {
        lol = window.visualViewport.height;
      } else {
        lol = window.innerHeight;
      }
      */
      if (value === this.lastVhValue) {
        return;
      }

      this.lastVhValue = value;

      this.$vhcheck.emit('update');

      /*
      this.$refs.message.show({
        title:`vh-check: isNeeded: ${isNeeded} value: ${value} vh: ${vh} windowHeight: ${windowHeight} offset: ${offset}`
      });
      */
    },
    startLoading(o) {
      this.pendingRequests.push(o);
      if (!this.$refs || !this.$refs.topProgress) {
        return;
      }
      if (this.pendingRequests.length === 1) {
        this.$refs.topProgress.start();
      } else {
        this.$refs.topProgress.decrease(5);
      }
    },
    stopLoading(o) {
      this.pendingRequests.pop();
      if (!this.$refs || !this.$refs.topProgress) {
        return;
      }
      if (this.pendingRequests.length === 0) {
        setTimeout( () => {
          if (this.pendingRequests.length <= 0) {
            this.$refs.topProgress.done();
          } else {
            this.$refs.topProgress.increase(10);
          }
        }, 500);
      }
    },
    clearLoad() {
      this.pendingRequests = [];
    },
    async readUser() {
      try {
        const session = await this.$amplify.Auth.currentSession();
        this.$eventbus.emit('authed');
        this.$store.commit('loggedIn');
        this.$store.commit('setJwtToken', session.getAccessToken().getJwtToken());

        const sub = session.idToken.payload.sub;

        //await this.changeUsername(loggedInUser);

        const user = await this.$apollo.query({
          //fetchPolicy: 'network-only',
          query:whoamiQuery,
        });

        this.user = user.data.whoami;
        this.$store.commit('setUser', this.user);

        this.startUserTokenRefreshInBackground();

        this.$ana.track({
          eventCategory: 'ui',
          eventAction: 'userLoggedIn'
        });

        if (this.__redirectToUser) {
          this.$router.push({
            name:'userposts',
            params:{
              username:this.user.username
            }
          });
        }
        return true;
      } catch (e) {
        this.$ana.track({
          eventCategory: 'ui',
          eventAction: 'userAnonymous'
        });
        return false;
      }
      //this.identityId = loggedInUser;
    },

    async changeUsername() {
      const changeUsername = await this.$apollo.mutate({
        mutation:gql(`
          mutation changeUsername(
            $username: String!
            )  {

            changeUsername(
              username: $username
            ) 
          }
          `),
        variables: {
          username:'sakkieuser3',
        }
      });

    },
    async changedUsername() {
      await this.readUser();
    },
    startUserTokenRefreshInBackground() {
      // https://github.com/aws-amplify/amplify-js/issues/2560
      setInterval( async () => {
        const cognitoUser = await Auth.currentAuthenticatedUser();
        const currentSession = await Auth.currentSession();
        cognitoUser.refreshSession(currentSession.refreshToken, (err, session) => {
          console.log('new session', err, session);
        });
      }, 10 * 60 * 1000);
    },
    async readFile(id) {
      const api = getProviders().api;
      const data = await fetch(api.makeStashUrl(id))
      const stashdata = await data.json();
      return stashdata;
    },
    async handleStash(id) {
      try {
        // first, try and find the draft with this id
        const stash = await this.readFile(id);
        const draftId = stash.id;
        if (stash.type === 'draft') {

          this.isLoadingStash = true;
          const data = await this.$apollo.query({
            query:getPostDraftsQuery,
            client:'localClient',
            clientId:'localClient',
          });
          this.isLoadingStash = false;
          console.log('the post drafts data', data);
          const drafts = (((data||{}).data||{}).postDrafts||[]).filter( ({id}) => {
            return id === draftId;
          });
          if (drafts.length) {
            console.log('simply reading from draft');
            this.$router.push({
              name:'create',
              params:{
                draftId,
                autoPost:true,
                type:"post"
              }
            });
            this.$ana.track({
              eventCategory:'login',
              eventAction:'draftFound'
            });
          } else {
            // somtimes, localstorage seems to be empty or something, which means
            // they lose their post after they login. so take the stashed
            // data and then create a new draft

            let stashDraftId = draftId + "-stash";
            const newDraft = {
              id:stashDraftId,
              updated:stash.created,
              created:stash.created,
              parentId:stash.parentId,
              opId:stash.opId,
              title:stash.title,
              type:'draft',
              gamedata:JSON.stringify(stash.data)
            }
            console.log('stashId is', id);
            console.log('found the stash yes', stash);
            await this.$apollo.mutate({
              mutation:savePostDraftQuery,
              //mutation:addItemQuery,
              fetchPolicy:'no-cache',
              client:'localClient',
              variables:newDraft
            });

            this.$router.push({
              name:'create',
              params:{
                draftId:stashDraftId,
                autoPost:true,
                type:"post"
              }
            });

            this.$ana.track({
              eventCategory:'login',
              eventAction:'draftLost'
            });

          }
        } else {
          this.$router.push({
            name:'createTextPost',
            params:{
              id:stash.parentId,
              draftId:stash.id,
              stash:id,
              autoPost:true,
              body:stash.body,
              type:"text"
            }
          });
        }

      } catch (e) {
        this.$ana.track({
          eventCategory:'login',
          eventAction:'draftError'
        });
      }
      this.isLoadingStash = false;

    },
    async doInstallAppFlow() {
      await this.onAppInstallConfirmed();
      this.showNotificationsInstallPrompt = true;

    },
    onAppInstallConfirmed() {
      return new Promise( (resolve,reject) => {
        this.deferredInstallPrompt.prompt();
        // Wait for the user to respond to the prompt:
        this.$ana.track({
          eventCategory:'install',
          eventAction:'yes'
        });
        this.deferredInstallPrompt.userChoice.then((choiceResult) => {

          this.deferredInstallPrompt = null;

          if (choiceResult.outcome === "accepted") {
            console.log("User accepted the install prompt");
            this.$ana.track({
              eventCategory:'install',
              eventAction:'confirmed'
            });
            resolve();
          } else {
            console.log("User dismissed the install prompt");
            this.$ana.track({
              eventCategory:'install',
              eventAction:'denied'
            });
            resolve();
          }
  
        });
      });
    },
    onApAddedCancelled() {
      this.deferredInstallPrompt = null;
      this.$ana.track({
        eventCategory:'install',
        eventAction:'cancelled'
      });
    },
    async onNotificationsInstallConfirmed() {
      try {
        const acked = await this.$messaging.requestPermission();
        const token = await this.$messaging.getToken();

        await this.$apollo.mutate({
          mutation:gql(`
            mutation updatePushToken(
              $token: String!,
              $user: String!
              )  {

              updatePushToken(
                token: $token,
                user: $user
              )
            }
            `),
          variables: {
            user:'anonymous',
            token
          }
        });


        this.$ana.track({
          eventCategory:'install',
          eventAction:'notificationsConfirm'
        });
        this.showNotificationsInstallPrompt = false;
      } catch (e) {
        console.error("error", e);
        this.$ana.track({
          eventCategory:'install',
          eventAction:'notificationsDenied'
        });
        this.showNotificationsInstallPrompt = false;
        throw e;
      }
    },
    onNotificationsInstallCancelled() {
      this.$ana.track({
        eventCategory:'install',
        eventAction:'notificationsCancelled'
      });
      this.showNotificationsInstallPrompt = false;
    }

  },
  computed:{
    showConfirmNavigateAwayFromEditor() {
      return !!this.navigateAwayFromEditor
    },
    showLoginDialog() {
      return this.$route.query.loginPrompt === true;
    },
    routerClasses() {
      const anyRouteIsNewOrHot = this.$route.matched.filter( ({name}) => {
        return name === 'new' || name === 'hot';
      }).length;
      if (this.$route.name === 'index' || this.$route.name === "userposts" || this.$route.name === "login" || anyRouteIsNewOrHot) { 
        return 'grow overflow-hidden';
      } else if (this.$route.name === 'play') {
        return 'grow overflow-hidden';
      } else {
        return 'grow';
      }
    },
    mainClass() {
      const anyRouteIsNewOrHot = this.$route.matched.filter( ({name}) => {
        return name === 'new' || name === 'hot';
      }).length;
      if (anyRouteIsNewOrHot) {
        return 'top-area h-screen-fixed-main-page-lol';
      } else if (this.$route.name === 'play') {
        return 'top-area h-screen-fixed-main-page-lol';
      } else {
        return 'h-screen-fixed';
      }
    },
    forceUsernameChange() {
      return this.user.username.toLowerCase().indexOf('google_') === 0 || this.user.username.toLowerCase().indexOf('facebook_') === 0;
    },
    showNavbar() {
      return this.$route.name !== 'record';
    },
    canInstallApp() {
      //return this.deferredInstallPrompt || true;
      return this.deferredInstallPrompt;
    },
    showAppInstallPrompt() {
      return this.canInstallApp && ((!this.forceUsernameChange && this.user.username !== 'anonymous')) && this.hasPosted;
    },
    ...mapState(['postsViewed'])
  },
  watch:{
    postsViewed(nv) {
      if (nv > 0 && nv % 5 === 0 && this.canInstallApp) {
        this.$eventbus.emit("inlineAppInstall");
      }
    },
    deferredInstallPrompt(nv) {
      if (!!nv) {
        this.$store.commit('setCanInstallApp', true);
      } else {
        this.$store.commit('setCanInstallApp', false);
      }
    }
  },
  props:{
  }
}
</script>

<style>
.red-square {
  background-color:red;
  color: blue;
}
</style>
